import { DefaultTheme } from 'styled-components'

export const theme: DefaultTheme = {
  colors: {
    black: '#1E293B',
    lightBlack: '#293445',
    gray: '#E4E5E7',
    primary: '#1FC8E1',
    white: '#FAFAFA',
    secondary: '#2DD4BF',
    primaryDark: '#18A1B5',
    whiteWithOpacity: 'rgba(255, 255, 255, 0.65)',
    linkItemHover: 'rgba(255, 255, 255, 0.05)',
  },
}
